module.exports = __webpack_public_path__ + "static/media/logo-yellow.47938ebe.png";